import {Component} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";

@Component({
    selector: 'welcome-modal',
    templateUrl: './welcome-modal.component.html',
    styleUrls: ['./welcome-modal.component.scss'],
    standalone: false
})
export class WelcomeModalComponent {

    displayText: string;

    constructor(
        public bsModalRef: BsModalRef
    ) { }

    cancel() {
        this.bsModalRef.hide();
    }
}
